import React from 'react'
import {Card} from 'antd'

export default function Loading() {
  return (
    <Card loading={true} title={<strong>Loading Sections...</strong>} style={{textAlign: `left`, margin: `1.5rem`}} />
  )
}
